import { Component, OnInit } from '@angular/core';
import { TokenStorageService } from './_services/token-storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  private roles: string[] = [];
  isLoggedIn = false;
  showAdminBoard = false;
  customerdashboard = false;
  editprofile = false;
  username?: string;
  title: any;

  constructor(private tokenStorageService: TokenStorageService) { }

  ngOnInit(): void {
    this.isLoggedIn = !!this.tokenStorageService.getToken();

    if (this.isLoggedIn) {
      const user = this.tokenStorageService.getUser();
      this.roles = user.roles;

      // this.showAdminBoard = this.roles.includes('ROLE_ADMIN');
      this.customerdashboard = this.roles.includes('ROLE_CUSTOMER');
      this.editprofile = this.roles.includes('ROLE_ARTIST');

      this.username = user.username;
    }
  }

  logout(): void {
    this.tokenStorageService.signOut();
    //window.location.reload();
  }
}
